import React, {useEffect, useState} from 'react';
import 'primeflex/primeflex.min.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css'
import './lib/styles/primereact-overrides.css'
import './lib/styles/app.css'
import 'typicons.font/src/font/typicons.css'
import {Navigation} from "./lib/navigation/Navigation";
import {configureApp} from "./lib/config";
import {useIntl} from "react-intl";
import {useUserInfo} from "./lib/hooks/useUserInfo";
import {Routes} from "react-router-dom";
import {authRoutes, brokerRoutes, routes} from "./routes";
import Preloader from "./lib/Preloader";
import {useCheckIfAuthenticated} from "./lib/hooks/swr/auth/useCheckIfAuthenticated";
import {useLiveSessionInfo} from "./lib/hooks/swr/session/useLiveSessionInfo";
import BrokerNavigation from "./lib/navigation/BrokerNavigation";

function App() {
    const {formatMessage: f} = useIntl();
    const {userInfo, updateUserInfo} = useUserInfo();
    configureApp(f);

    const [isLoading, setIsLoading] = useState(true);

    const isBroker = userInfo.role === 'ROLE_BROKER';

    // While user is in process of changing password, checkIfAuthenticated should not be triggered because it causes the change password form to reset.
    const {data: userData, error: checkIfAuthenticatedError} = useCheckIfAuthenticated(userInfo.shouldChangePassword);
    const {data: liveSessionInfo} = useLiveSessionInfo(userInfo.authenticated && !userInfo.shouldChangePassword && !isBroker);


    useEffect(() => {
        if (userData) {
            updateUserInfo({...userData, authenticated: true});
            setIsLoading(false);
        }
    }, [userData]);

    useEffect(() => {
        updateUserInfo({liveSessionInfo});
    }, [liveSessionInfo]);


    useEffect(() => {
        if (checkIfAuthenticatedError)
            setIsLoading(false);
    }, [checkIfAuthenticatedError]);


    if (isLoading)
        return <Preloader/>

    return <>
        {isBroker ? <BrokerNavigation/> : <Navigation/>}
        <React.Suspense fallback={<Preloader/>}>
            <main>
                <div className={'container'}>
                    <Routes>
                        {(!userInfo.authenticated || userInfo.shouldChangePassword) ? authRoutes
                            : isBroker ? brokerRoutes : routes}
                    </Routes>
                </div>
            </main>
        </React.Suspense>
    </>
}

export default App;
